import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MaskedInput from 'react-text-mask';

import { removeMaskFromEvent } from '@/utils/mask/removeMask';
import { cepMask } from '@/utils/mask/commonMasks';
import { maskFieldValidator } from '@/utils/mask';

import FloatingFormItem from '../FloatingFormItem';

const ZipFormField = ({
  label,
  onChange,
  fieldName,
  requiredRuleTextId,
  lengthRuleTextId,
  initialValue,
  required,
  getValueFromEvent,
  disable,
}) => {
  const intl = useIntl();

  const rules = [
    required
      ? {
          required: true,
          message: intl.formatMessage({ id: requiredRuleTextId }),
        }
      : null,
    {
      min: 8,
      max: 8,
      validator: maskFieldValidator,
      message: intl.formatMessage({ id: lengthRuleTextId }),
    },
  ].filter((i) => i);

  return (
    <FloatingFormItem
      label={label}
      name={fieldName}
      initialValue={initialValue}
      getValueFromEvent={(event) => {
        const formatted = removeMaskFromEvent(event);

        if (getValueFromEvent) getValueFromEvent(formatted);

        return formatted;
      }}
      rules={rules}
    >
      <MaskedInput
        disabled={disable}
        className="ant-input"
        mask={cepMask}
        onChange={onChange}
      />
    </FloatingFormItem>
  );
};

ZipFormField.propTypes = {
  onChange: PropTypes.func,

  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  fieldName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  requiredRuleTextId: PropTypes.string,
  lengthRuleTextId: PropTypes.string,
  initialValue: PropTypes.string,

  required: PropTypes.bool,

  getValueFromEvent: PropTypes.func,
};

ZipFormField.defaultProps = {
  fieldName: 'zip',
  label: 'CEP',
  requiredRuleTextId: 'commons.form.errors.requiredCep',
  lengthRuleTextId: 'commons.form.errors.invalidCep',
  required: true,
};

export default ZipFormField;
